import { BaseDataModel } from "./base";

export class JobReady extends BaseDataModel {
	name!: string;
	jobIds!: string[];
	submissionNotes!: string;
	priority!: string;
	submitter!: string;
}
